import styled from 'styled-components';

export const StyledActionsContainer = styled.div`
  display: flex;
  gap: 1rem;
`;
